export default __webpack_public_path__ + "static/media/zincoinsGrey.4a48b09c.svg";